/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Alt_T_Pdfcraft_FilesInputs */

const en_pc_alt_t_pdfcraft_files = /** @type {(inputs: Pc_Alt_T_Pdfcraft_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`On your device`)
};

const zh_pc_alt_t_pdfcraft_files = /** @type {(inputs: Pc_Alt_T_Pdfcraft_FilesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在你的设备上`)
};

/**
* | output |
* | --- |
* | "On your device" |
*
* @param {Pc_Alt_T_Pdfcraft_FilesInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_alt_t_pdfcraft_files = /** @type {((inputs?: Pc_Alt_T_Pdfcraft_FilesInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Alt_T_Pdfcraft_FilesInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_alt_t_pdfcraft_files(inputs)
	return zh_pc_alt_t_pdfcraft_files(inputs)
});
export { pc_alt_t_pdfcraft_files as "pc.alt.t.pdfcraft.files" }